'use client';

import { BrainCircuit, Clock, Link2Off, ShieldOff } from 'lucide-react';
import { ReactNode } from 'react';

const problems = [
  {
    title: 'Leggi che non esistono',
    description:
      'Citazioni inventate ma credibili, che minano la tua autorevolezza e possono portare a gravi errori.',
    icon: <BrainCircuit />,
  },
  {
    title: 'Informazioni datate',
    description:
      'Norme superate o abrogate che restano nei testi, mettendo a rischio pareri e contratti.',
    icon: <Clock />,
  },
  {
    title: 'Fonti inesistenti',
    description:
      'Senza riferimenti verificabili, è impossibile garantire l’autenticità di ciò che presenti.',
    icon: <Link2Off />,
  },
  {
    title: 'Dati sensibili a rischio',
    description:
      'Fornire documenti e informazioni riservate può esporre alla loro conservazione o uso improprio.',
    icon: <ShieldOff />,
  },
];

const AIProblemSection = () => {
  return (
    <section id="aiProblems" className="py-16 px-4 md:px-8 bg-white scroll-mt-12">
      <div className="max-w-xl md:max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-primary font-funnel mb-6">
          Quanto <span className="text-accent">stai rischiando</span> affidandoti ad un&apos;AI
          generalista?
        </h2>
        <p className="text-lg text-neutral-700 mb-12">
          Se usi ChatGPT o altri chatbot generalisti per il tuo lavoro, la precisione è a rischio.
          <br />
          Studi di settore dimostrano che oltre il 50% delle risposte contiene informazioni
          incomplete o errate<sup>*</sup>.
          <br />
          <span className="inline-block text-xs text-neutral-500 mt-2 leading-relaxed">
            <sup>*</sup>Ricerca &quot;Large Legal Fictions: Profiling Legal Hallucinations in Large
            Language Models&quot; delle università di Stanford e Yale.
          </span>
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 text-left">
          {problems.map((problem, i) => (
            <AIProblemCard
              key={i}
              title={problem.title}
              description={problem.description}
              icon={problem.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

interface ProblemCardProps {
  title: string;
  description: string;
  icon: ReactNode;
}

const AIProblemCard = ({ title, description, icon }: ProblemCardProps) => {
  return (
    // Layout principale modificato con Flexbox
    <div className="flex items-start space-x-6 rounded-xl bg-white p-6 shadow-md hover:shadow-lg transition duration-200 border border-neutral-200">
      {/* Container per l'icona */}
      <div className="flex-shrink-0 bg-accent-100 text-accent rounded-full p-4">{icon}</div>

      {/* Container per il testo */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-1">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default AIProblemSection;
